import Cookies from 'js-cookie';
import ConsentedCookie from '../../../../scripts/classes/ConsentedCookie';
import LocaleHost from '../../../../scripts/classes/LocaleHost';
import gsap from 'gsap';
import ScrollToPlugin from 'gsap/ScrollToPlugin';
import jstree from 'jstree';
import CitiesSelect from "./CitiesSelect";

gsap.registerPlugin(ScrollToPlugin);

var JobListing = function (options) {

	this.options = {
		$el: false,
		baseClass: 'job-listing',
	};

	$.extend(true, this.options, options);

};

/*
 *	Init function
 */
JobListing.prototype.init = function () {

	var self = this;

	// dom elements
	this.$keywordSearchInputs = self.options.$el.find(`.${self.options.baseClass}__keywordSearch__keywordSearchInput`);
	this.$keywordSearchInput = this.options.$el.find(`.${self.options.baseClass}__keywordSearchWrapper .${self.options.baseClass}__keywordSearch__keywordSearchInput`);
	this.$mobileKeywordSearchInput = this.options.$el.find(`.${self.options.baseClass}__keywordSearchWrapper--mobile .${self.options.baseClass}__keywordSearch__keywordSearchInput`);
	this.$filterWrappers = this.options.$el.find(`.${self.options.baseClass}__dropdownFilterWrapper`);

	this.$locationFilter = this.options.$el.find(`.${self.options.baseClass}__dropdownFilter--location .${self.options.baseClass}__dropdownFilter__filter`);
	this.$locationFilterWrapper = this.options.$el.find(`.${self.options.baseClass}__dropdownFilter--location`);
	this.$departmentFilter = this.options.$el.find(`.${self.options.baseClass}__dropdownFilter--department .${self.options.baseClass}__dropdownFilter__filter`);
	this.$departmentFilterWrapper = this.options.$el.find(`.${self.options.baseClass}__dropdownFilter--department`);
	this.$employmentTypeFilter = this.options.$el.find(`.${self.options.baseClass}__dropdownFilter--employment-type .${self.options.baseClass}__dropdownFilter__filter`);
	this.$employementTypeFilterWrapper = this.options.$el.find(`.${self.options.baseClass}__dropdownFilter--employment-type`);
	this.$cityFilter = this.options.$el.find(`.${self.options.baseClass}__dropdownFilter--city .${self.options.baseClass}__dropdownFilter__filter`);
	this.$cityFilterWrapper = this.options.$el.find(`.${self.options.baseClass}__dropdownFilter--city`);
	this.$locationTypeFilter = this.options.$el.find(`.${self.options.baseClass}__dropdownFilter--locationType .${self.options.baseClass}__dropdownFilter__filter`);
	this.$locationTypeFilterWrapper = this.options.$el.find(`.${self.options.baseClass}__dropdownFilter--locationType`);

	this.departmentFilterDefaultText = 'Filter by Department';
	this.locationFilterDefaultText = 'Filter by Country';
	this.employmentTypeFilterDefaultText = 'Filter by Employment Type';
	this.cityFilterDefaultText = 'Filter by City';
	this.locationTypeFilterDefaultText = 'Filter by Location Type';

	this.$dropdownFilterHeadings = this.options.$el.find(`.${self.options.baseClass}__dropdownFilter__heading`);
	this.$filterButtonWrapper = this.options.$el.find(`.${self.options.baseClass}__submitFiltersButton`);
	this.$filterButton = this.options.$el.find(`.${self.options.baseClass}__submitFiltersButton button`);
	this.$filterCollapseTrigger = this.options.$el.find(`.${self.options.baseClass}__filterCollapseTrigger`);
	this.$filterCollapseWrapper = this.options.$el.find(`.${self.options.baseClass}__filterCollapseWrapper`);
	this.$filterCollapseIndicator = this.$filterCollapseTrigger.find(`.${self.options.baseClass}__filterCollapseTrigger__openCloseIndicator span`).eq(0);
	this.$activeFilterTagsWrapper = this.options.$el.find(`.${self.options.baseClass}__activeFilterTags`);
	this.$heightAdjustWrapper = this.options.$el.find(`.${self.options.baseClass}__resultsPaginationWrapper`);
	this.$paginationWrapper = this.options.$el.find(`.${self.options.baseClass}__pagination`);
	this.$placeholdersContainer = this.options.$el.find(`.${self.options.baseClass}__results--placeholders`);
	this.$resultsContainer = this.options.$el.find(`.${self.options.baseClass}__results--container`);
	this.$noResultsContainer = this.options.$el.find(`.${self.options.baseClass}__results--noResults`);
	this.$jobResultTemplate = this.options.$el.find(`.${self.options.baseClass}__resultWrapper--resultTemplate`);
	this.$filtersLoader = this.options.$el.find(`.${self.options.baseClass}__filtersLoader`);
	this.$clearFiltersButton = this.options.$el.find(`.${self.options.baseClass}__clearFiltersButton`);

	this.selectedDropdownFilterClass = `${self.options.baseClass}__dropdownFilter--selected`;

	// state variables
	this.loadStartTime = new Date().getTime() / 1000;

	// these variables will hold the most recently submitted search/filters, and will be used
	// by the pagination links
	this.submittedQuery = '';
	this.submittedDepartmentFilters = [];
	this.submittedEmploymentTypeFilters = [];
	this.submittedLocationFilters = [];
	this.submittedCityFilters = [];
	this.submittedLocationTypeFilters = [];

	// kick things off
	this.initFilters();
	this.initPagination();

	this.citiesSelectWrapper = this.options.$el.find('[data-cities-select]');
	this.citiesSelect = new CitiesSelect(this.citiesSelectWrapper, this.$cityFilter);
	this.citiesSelect.resetCities();

	// get our URL parameters
	let searchParams = new URLSearchParams(window.location.search);

	// this boolean will track whether any filters were set via URL parameters
	let urlParametersSet = false;

	// check if department filter is being set via URL parameter
	if (searchParams.has('department')) {

		// department URL param is set, so update the filter before submitting
		let departmentId = searchParams.get('department'); // get URL parameter value

		this.$departmentFilter.jstree('open_all'); // open all nodes (they must be opened to check one)
		let departmentNode = $(`[data-id="${departmentId}"]`); // get the node by ID
		this.$departmentFilter.jstree('select_node', departmentNode); // select the node
		this.$departmentFilter.jstree('close_all'); // close all nodes

		// remove the URL parameter so that if a job is clicked then the back button is used, filter updates will remain
		var state = {};
		var title = '';
		var currentUrlWithoutParams = location.protocol + '//' + location.host + location.pathname;
		var url = new URL(currentUrlWithoutParams);
		// url.searchParams.set('unitDetail', unitId);
		window.history.replaceState(state, title, url);

		urlParametersSet = true; // set our boolean so we know filters were set via URL parameter

	}

	// check if employment type filter is being set via URL parameter
	if (searchParams.has('employment_type')) {

		// department URL param is set, so update the filter before submitting
		let employmentTypeId = searchParams.get('employment_type'); // get URL parameter value

		this.$employmentType.jstree('open_all'); // open all nodes (they must be opened to check one)
		let employmentTypeNode = $(`[data-id="${employmentTypeId}"]`); // get the node by ID
		this.$employmentType.jstree('select_node', employmentTypeNode); // select the node
		this.$employmentType.jstree('close_all'); // close all nodes

		// remove the URL parameter so that if a job is clicked then the back button is used, filter updates will remain
		var state = {};
		var title = '';
		var currentUrlWithoutParams = location.protocol + '//' + location.host + location.pathname;
		var url = new URL(currentUrlWithoutParams);
		// url.searchParams.set('unitDetail', unitId);
		window.history.replaceState(state, title, url);

		urlParametersSet = true; // set our boolean so we know filters were set via URL parameter

	}

	// check if city filter is being set via URL parameter
	if (searchParams.has('city')) {

		// city URL param is set, so update the filter before submitting
		let cityId = searchParams.get('city'); // get URL parameter value

		this.$cityFilter.jstree('open_all'); // open all nodes (they must be opened to check one)
		let cityNode = $(`[data-id="${cityId}"]`); // get the node by ID
		this.$cityFilter.jstree('select_node', cityNode); // select the node
		this.$cityFilter.jstree('close_all'); // close all nodes

		// remove the URL parameter so that if a job is clicked then the back button is used, filter updates will remain
		var state = {};
		var title = '';
		var currentUrlWithoutParams = location.protocol + '//' + location.host + location.pathname;
		var url = new URL(currentUrlWithoutParams);
		// url.searchParams.set('unitDetail', unitId);
		window.history.replaceState(state, title, url);

		urlParametersSet = true; // set our boolean so we know filters were set via URL parameter

	}

	// check if region filter is being set via URL parameter
	if (searchParams.has('location')) {

		// region URL param is set, so update the filter before submitting
		let regionName = searchParams.get('location');

		this.$locationFilter.jstree('open_all'); // open all nodes (they must be opened to check one)
		let regionNode = $(`[data-region="${regionName}"]`); // get the node by ID
		this.$locationFilter.jstree('select_node', regionNode); // select the node
		this.$locationFilter.jstree('close_all'); // close all nodes

		// remove the URL parameter so that if a job is clicked then the back button is used, filter updates will remain
		var state = {};
		var title = '';
		var currentUrlWithoutParams = location.protocol + '//' + location.host + location.pathname;
		var url = new URL(currentUrlWithoutParams);
		// url.searchParams.set('unitDetail', unitId);
		window.history.replaceState(state, title, url);

		urlParametersSet = true; // set our boolean so we know filters were set via URL parameter

	}

	// check if location filter is being set via URL parameter
	if (searchParams.has('locationType')) {

		// location URL param is set, so update the filter before submitting
		let locationId = searchParams.get('locationType'); // get URL parameter value

		this.$locationTypeFilter.jstree('open_all'); // open all nodes (they must be opened to check one)
		let locationNode = $(`[data-id="${locationId}"]`); // get the node by ID
		this.$locationTypeFilter.jstree('select_node', locationNode); // select the node
		this.$locationTypeFilter.jstree('close_all'); // close all nodes

		// remove the URL parameter so that if a job is clicked then the back button is used, filter updates will remain
		var state = {};
		var title = '';
		var currentUrlWithoutParams = location.protocol + '//' + location.host + location.pathname;
		var url = new URL(currentUrlWithoutParams);
		// url.searchParams.set('unitDetail', unitId);
		window.history.replaceState(state, title, url);

		urlParametersSet = true; // set our boolean so we know filters were set via URL parameter

	}

	// check if search box is being set via URL parameter
	if (searchParams.has('query')) {

		// region URL param is set, so update the filter before submitting
		let searchQuery = searchParams.get('query');

		this.$keywordSearchInput.val(searchQuery);
		this.$mobileKeywordSearchInput.val(searchQuery);

		// remove the URL parameter so that if a job is clicked then the back button is used, filter updates will remain
		var state = {};
		var title = '';
		var currentUrlWithoutParams = location.protocol + '//' + location.host + location.pathname;
		var url = new URL(currentUrlWithoutParams);
		// url.searchParams.set('unitDetail', unitId);
		window.history.replaceState(state, title, url);

		urlParametersSet = true; // set our boolean so we know filters were set via URL parameter

	}

	// check if any filters were set via URL parameter
	if (!urlParametersSet) {
		// no URL parameters were set

		// get our filter settings from cookies, so we can reload the previous jobListing state
		let savedQuery = Cookies.get('jobListingQuery');
		let departmentToSelect = Cookies.get('jobListingDepartment');
		let employmentTypeToSelect = Cookies.get('jobListingEmploymentType');
		let cityToSelect = Cookies.get('jobListingCity');
		let locationToSelect = Cookies.get('jobListingLocation');
		let currentRegion = Cookies.get('region');
		let locationTypeToSelect = Cookies.get('jobListingLocationType');

		// check if a search query was saved in cookies
		if (savedQuery) {
			this.$keywordSearchInput.val(savedQuery);
			this.$mobileKeywordSearchInput.val(savedQuery);
		}

		// check if an department filter value was saved in cookies
		if (departmentToSelect) {

			let departmentIds = departmentToSelect.split('|');

			this.$departmentFilter.jstree('open_all'); // open all nodes (they must be opened to check one)

			for (let i = 0; i < departmentIds.length; i++) {

				let departmentId = departmentIds[i];

				let departmentNode = $(`[data-id="${departmentId}"]`); // get the node by ID
				this.$departmentFilter.jstree('select_node', departmentNode); // select the node

			}

			this.$departmentFilter.jstree('close_all'); // close all nodes

		}

		// check if an employment type value was saved in cookies
		if (employmentTypeToSelect) {

			let employmentTypeIds = employmentTypeToSelect.split('|');

			this.$employmentTypeFilter.jstree('open_all'); // open all nodes (they must be opened to check one)

			for (let i = 0; i < employmentTypeIds.length; i++) {

				let employmentTypeId = employmentTypeIds[i];

				let employmentTypeNode = $(`[data-id="${employmentTypeId}"]`); // get the node by ID
				this.$employmentTypeFilter.jstree('select_node', employmentTypeNode); // select the node

			}

			this.$employmentTypeFilter.jstree('close_all'); // close all nodes

		}

		// check if a city filter value was saved in cookies
		if (cityToSelect) {

			let cityIds = cityToSelect.split('|');

			this.$cityFilter.jstree('open_all'); // open all nodes (they must be opened to check one)

			for (let i = 0; i < cityIds.length; i++) {

				let cityId = cityIds[i];

				let cityNode = $(`[data-id="${cityId}"]`); // get the node by ID
				this.$cityFilter.jstree('select_node', cityNode); // select the node

			}

			this.$cityFilter.jstree('close_all'); // close all nodes

		}

		// check if a location type filter value was saved in cookies
		if (locationTypeToSelect) {

			let locationTypeIds = locationTypeToSelect.split('|');

			this.$locationTypeFilter.jstree('open_all'); // open all nodes (they must be opened to check one)

			for (let i = 0; i < locationTypeIds.length; i++) {

				let locationTypeId = locationTypeIds[i];

				let locationTypeNode = $(`[data-id="${locationTypeId}"]`); // get the node by ID
				this.$locationTypeFilter.jstree('select_node', locationTypeNode); // select the node

			}

			this.$locationTypeFilter.jstree('close_all'); // close all nodes

		}

		// if region is set, filter by it
		if (currentRegion) {

			this.$locationFilter.jstree('open_all'); // open all nodes (they must be opened to check one)
			let regionNode = $(`[data-region="${currentRegion}"]`); // get the node by ID
			this.$locationFilter.jstree('select_node', regionNode); // select the node
			this.$locationFilter.jstree('close_all'); // close all nodes

		}
		// if location was previously selected, set back to that value
		else if (locationToSelect) {

			let locationIds = locationToSelect.split('|');

			this.$locationFilter.jstree('open_all'); // open all nodes (they must be opened to check one)

			for (let i = 0; i < locationIds.length; i++) {

				let locationId = locationIds[i];
				let locationNode = $(`#${locationId}`); // get the node by ID

				this.$locationFilter.jstree('select_node', locationNode); // select the node

			}

			this.$locationFilter.jstree('close_all'); // close all nodes

		}

	}

	this.submitFilters();
	this.citiesSelect.updatefilterCities();

};

// this function initializes all of our filters
JobListing.prototype.initFilters = function () {

	var self = this;

	this.$departmentFilter.jstree({
		"core": {
			"themes": {
				"icons": false
			},
			"loaded_state": true
		},
		"checkbox": {
			// cascade: 'down'
			// "keep_selected_style" : false
		},
		"plugins": ["checkbox"]
	});

	this.$employmentTypeFilter.jstree({
		"core": {
			"themes": {
				"icons": false
			},
			"loaded_state": true
		},
		"checkbox": {
			// cascade: 'down'
			// "keep_selected_style" : false
		},
		"plugins": ["checkbox"]
	});

	this.$cityFilter.jstree({
		"core": {
			"themes": {
				"icons": false
			},
			"loaded_state": true
		},
		"checkbox": {
			// cascade: 'down'
			// "keep_selected_style" : false
		},
		"plugins": ["checkbox"]
	});

	this.$locationFilter.jstree({
		"core": {
			"themes": {
				"icons": false
			}
		},
		"checkbox": {
			// cascade: 'down'
			// "keep_selected_style" : false
		},
		"plugins": ["checkbox", "sort"]
	});

	this.$locationTypeFilter.jstree({
		"core": {
			"themes": {
				"icons": false
			},
		},
		"checkbox": {
			// cascade: 'down'
			// "keep_selected_style" : false
		},
		"plugins": ["checkbox", "sort"]
	});

	// when a dropdown filter heading is clicked
	this.$dropdownFilterHeadings.on('click', function () {

		let $dropdownFilter = $(this).closest(`.${self.options.baseClass}__dropdownFilter`);

		// check if the filter is currently active, and toggle
		if ($dropdownFilter.hasClass(`${self.options.baseClass}__dropdownFilter--active`)) {
			self.closeDropdownFilter($dropdownFilter);
		}
		else {
			self.openDropdownFilter($dropdownFilter);
		}

	});

	// setting up our timeline to open/close filters
	this.filterCollapseTimeline = gsap.timeline({
		defaults: {
			duration: 0.3
		}
	})
		.to(self.$filterCollapseIndicator, {
			rotation: 0,
			duration: 0.35,
			ease: "power1.inOut"
		}, 0)
		.to(self.$filterCollapseWrapper, {
			height: 'auto',
		}, 0).reverse();

	// when the filter show/hide button is clicked on mobile
	this.$filterCollapseTrigger.on('click', function () {
		self.filterCollapseTimeline.reversed(!self.filterCollapseTimeline.reversed());
	});

	// when the filter submit button is clicked
	this.$filterButton.on('click', function () {
		// set our loading state
		self.loading();
		self.submitFilters();
	});

	// when the enter key is pressed and the text search box has focus
	$(document).on('keypress', function (e) {
		if (e.which == 13) {
			if (self.$keywordSearchInput.is(":focus") || self.$mobileKeywordSearchInput.is(":focus")) {
				// set our loading state
				self.loading();
				self.submitFilters();
			}
		}
	});

	// make sure our mobile/desktop keyword search fields have the same value
	this.$keywordSearchInputs.on('input', function () {
		var value = $(this).val();
		self.$keywordSearchInputs.val(value);
		self.pulsateButton();
	});

	// when the clear filters button is clicked
	this.$clearFiltersButton.on('click', function () {
		self.clearAllFilters();
		// set our loading state
		self.loading();
		self.submitFilters();
	});

	// when a dropdown filter is changed
	this.$departmentFilter.on('changed.jstree', function (e, data) {

		self.handleDropdownFilterChange($(this), data);

	});

	this.$employmentTypeFilter.on('changed.jstree', function (e, data) {

		self.handleDropdownFilterChange($(this), data);

	});

	this.$cityFilter.on('changed.jstree', function (e, data) {

		self.handleDropdownFilterChange($(this), data);

	});

	this.$locationFilter.on('changed.jstree', function (e, data) {

		self.handleDropdownFilterChange($(this), data);
		self.citiesSelect.updatefilterCities();

	});

	this.$locationTypeFilter.on('changed.jstree', function (e, data) {

		self.handleDropdownFilterChange($(this), data);

	});

	// when clicking outside the filters, close them
	$(`body`).on('click', function () {

		if (window.Breakpoint.value != "xsmall" && window.Breakpoint.value != "small") {
			self.closeAllDropdownFilters();
		}

	});

	// when clicking a filter, don't close the filters (stops the above function from triggering)
	this.$filterWrappers.on('click', function (e) {
		e.stopPropagation();
	});

	// when clicking an active filter tag, update the filters
	this.$activeFilterTagsWrapper.on('click', `.${self.options.baseClass}__activeFilterTag`, function () {

		let tagType = $(this).data('tagType');

		// determine which type of filter tag was clicked so we can clear the appropriate filter
		switch (tagType) {
			case 'query':
				self.clearKeywordSearch();
				break;
			case 'department':
				self.clearDepartmentFilter();
				break;
			case 'employmentType':
				self.clearEmploymentTypeFilter();
				break;
			case 'city':
				self.clearCityFilter();
				break;
			case 'location':
				self.clearLocationFilter();
				break;
			case 'locationType':
				self.clearLocationTypeFilter();
				break;
		}

		// we use a timeline here so that the animation is smooth when a filter tag is clicked
		gsap.timeline()
			.to($(this), {
				duration: 0.25,
				opacity: 0
			})
			.add(function () {
				self.loading();
				self.submitFilters();
			});

	});

};

// this function handles a dropdown filter change
JobListing.prototype.handleDropdownFilterChange = function ($changedFilter, data) {

	var self = this;

	let $filterParent = $changedFilter.closest(`.${self.options.baseClass}__dropdownFilter`);

	if (data.selected.length) {
		$filterParent.addClass(self.selectedDropdownFilterClass);
	}
	else {
		$filterParent.removeClass(self.selectedDropdownFilterClass);
	}

	// jstree calls the change event in some situations where we don't want to pulsate the button, so we check
	// for those cases and exit early
	if (data.action == 'ready' || data.action == 'deselect_all') {
		return;
	}

	self.pulsateButton();

};

// Init our pagination links
JobListing.prototype.initPagination = function () {

	var self = this;

	this.options.$el.on('click', `.${self.options.baseClass}__pagination__link`, function () {
		self.goToPage($(this).data('page'));
	});

};

// Handles opening a dropdown filter
JobListing.prototype.openDropdownFilter = function ($dropdownFilter) {

	var self = this;

	self.closeAllDropdownFilters();

	let $filterWrapper = $dropdownFilter.find(`.${self.options.baseClass}__dropdownFilter__filterWrapper`);

	$dropdownFilter.addClass(`${self.options.baseClass}__dropdownFilter--active`);

	gsap.timeline()
		.set($filterWrapper, {
			overflow: 'hidden'
		})
		.to($filterWrapper, {
			height: 'auto',
			duration: 0.5,
		})
		.set($filterWrapper, {
			overflow: 'auto'
		});

};

// Closes all dropdown filters
JobListing.prototype.closeAllDropdownFilters = function () {

	var self = this;

	this.options.$el.find(`.${self.options.baseClass}__dropdownFilter`).each(function () {

		self.closeDropdownFilter($(this));

	});

};

// Closes a dropdown filter
JobListing.prototype.closeDropdownFilter = function ($dropdownFilter) {

	var self = this;

	let $filterWrapper = $dropdownFilter.find(`.${self.options.baseClass}__dropdownFilter__filterWrapper`);

	$dropdownFilter.removeClass(`${self.options.baseClass}__dropdownFilter--active`);

	gsap.timeline()
		.set($filterWrapper, {
			overflow: 'hidden'
		})
		.to($filterWrapper, {
			height: 0,
			duration: 0.35,
		})
		.set($filterWrapper, {
			overflow: 'auto'
		});

};

// Clears all filters
JobListing.prototype.clearAllFilters = function () {

	var self = this;

	this.clearKeywordSearch();
	this.clearDepartmentFilter();
	this.clearEmploymentTypeFilter();
	this.clearCityFilter();
	this.clearLocationFilter();
	this.clearLocationTypeFilter();

};

// Clears the keyword search
JobListing.prototype.clearKeywordSearch = function () {

	var self = this;
	this.$keywordSearchInput.val('');
	this.$mobileKeywordSearchInput.val('');

};

// Clears the department filter
JobListing.prototype.clearDepartmentFilter = function () {

	var self = this;
	this.$departmentFilter.jstree('deselect_all');

};

// Clears the employment type filter
JobListing.prototype.clearEmploymentTypeFilter = function () {

	var self = this;
	this.$employmentTypeFilter.jstree('deselect_all');

};

// Clears the city filter
JobListing.prototype.clearCityFilter = function () {

	var self = this;
	this.$cityFilter.jstree('deselect_all');

};

// Clears the location type filter
JobListing.prototype.clearLocationTypeFilter = function () {

	var self = this;
	this.$locationTypeFilter.jstree('deselect_all');

};

// Clears the location filter
JobListing.prototype.clearLocationFilter = function () {

	var self = this;
	this.$locationFilter.jstree('deselect_all');
	this.$locationFilter.find('[aria-selected]').attr('aria-selected', false)

	this.citiesSelect.resetCities();

};

// gets our filter values and passes them to updateJobResults
JobListing.prototype.submitFilters = function () {

	var self = this;

	// keyword search
	var query = this.$keywordSearchInput.val();

	ConsentedCookie.set('jobListingQuery', query, 'functional');

	// department filters
	var selectedTopLevelDepartmentFilters = this.$departmentFilter.jstree('get_top_checked', true);
	var selectedDepartmentFilters = this.$departmentFilter.jstree('get_checked', true);
	var selectedDepartmentHeadingText = '';
	var selectedDepartmentIds = [];

	// for each selected department filter
	for (let i = 0; i < selectedDepartmentFilters.length; i++) {
		selectedDepartmentIds = [...new Set([...selectedDepartmentIds, ...[selectedDepartmentFilters[i].data.id.toString()]])]; // filter out duplicates
	}

	// getting our updated heading text
	for (let i = 0; i < selectedTopLevelDepartmentFilters.length; i++) {
		selectedDepartmentHeadingText += selectedTopLevelDepartmentFilters[i].text.trim();

		if (i < selectedTopLevelDepartmentFilters.length - 1) {
			selectedDepartmentHeadingText += ', ';
		}

	}

	// update the filter heading text
	if (selectedDepartmentHeadingText) {
		this.$departmentFilterWrapper.find(`.${self.options.baseClass}__dropdownFilter__heading__text`).text(selectedDepartmentHeadingText);
	}
	else {
		this.$departmentFilterWrapper.find(`.${self.options.baseClass}__dropdownFilter__heading__text`).text(this.departmentFilterDefaultText);
	}

	// update department filters cookie
	ConsentedCookie.set('jobListingDepartment', selectedDepartmentIds.join('|'), 'functional');

	// employment type filters
	var selectedTopLevelEmploymentTypeFilters = this.$employmentTypeFilter.jstree('get_top_checked', true);
	var selectedEmploymentTypeFilters = this.$employmentTypeFilter.jstree('get_bottom_checked', true);
	var selectedEmploymentTypeHeadingText = '';
	var selectedEmploymentTypeIds = [];

	// for each selected employment type filter
	for (let i = 0; i < selectedEmploymentTypeFilters.length; i++) {
		selectedEmploymentTypeIds = [...new Set([...selectedEmploymentTypeIds, ...[selectedEmploymentTypeFilters[i].data.id.toString()]])]; // filter out duplicates
	}

	// getting our updated heading text
	for (let i = 0; i < selectedTopLevelEmploymentTypeFilters.length; i++) {
		selectedEmploymentTypeHeadingText += selectedTopLevelEmploymentTypeFilters[i].text.trim();

		if (i < selectedTopLevelEmploymentTypeFilters.length - 1) {
			selectedEmploymentTypeHeadingText += ', ';
		}

	}

	// update the filter heading text
	if (selectedEmploymentTypeHeadingText) {
		this.$employementTypeFilterWrapper.find(`.${self.options.baseClass}__dropdownFilter__heading__text`).text(selectedEmploymentTypeHeadingText);
	}
	else {
		this.$employementTypeFilterWrapper.find(`.${self.options.baseClass}__dropdownFilter__heading__text`).text(this.employmentTypeFilterDefaultText);
	}

	// update employment type filters cookie
	ConsentedCookie.set('jobListingEmploymentType', selectedEmploymentTypeIds.join('|'), 'functional');

	// city filters
	var selectedTopLevelCityFilters = this.$cityFilter.jstree('get_top_checked', true);
	var selectedCityFilters = this.$cityFilter.jstree('get_bottom_checked', true);
	var selectedCityHeadingText = '';
	var selectedCityIds = [];

	// for each selected city filter
	for (let i = 0; i < selectedCityFilters.length; i++) {
		selectedCityIds = [...new Set([...selectedCityIds, ...[selectedCityFilters[i].data.id.toString()]])]; // filter out duplicates
	}

	// getting our updated heading text
	for (let i = 0; i < selectedTopLevelCityFilters.length; i++) {
		selectedCityHeadingText += selectedTopLevelCityFilters[i].text.trim();

		if (i < selectedTopLevelCityFilters.length - 1) {
			selectedCityHeadingText += ', ';
		}

	}

	// update the filter heading text
	if (selectedCityHeadingText) {
		this.$cityFilterWrapper.find(`.${self.options.baseClass}__dropdownFilter__heading__text`).text(selectedCityHeadingText);
	} else {
		this.$cityFilterWrapper.find(`.${self.options.baseClass}__dropdownFilter__heading__text`).text(this.cityFilterDefaultText);
	}

	// update city filters cookie
	ConsentedCookie.set('jobListingCity', selectedCityIds.join('|'), 'functional');

	// location type filters
	var selectedTopLevelLocationTypeFilters = this.$locationTypeFilter.jstree('get_top_checked', true);
	var selectedLocationTypeFilters = this.$locationTypeFilter.jstree('get_bottom_checked', true);
	var selectedLocationTypeHeadingText = '';
	var selectedLocationTypeIds = [];

	// for each selected location type filter
	for (let i = 0; i < selectedLocationTypeFilters.length; i++) {
		selectedLocationTypeIds = [...new Set([...selectedLocationTypeIds, ...[selectedLocationTypeFilters[i].data.id.toString()]])]; // filter out duplicates
	}

	// getting our updated heading text
	for (let i = 0; i < selectedTopLevelLocationTypeFilters.length; i++) {
		selectedLocationTypeHeadingText += selectedTopLevelLocationTypeFilters[i].text.trim();

		if (i < selectedTopLevelLocationTypeFilters.length - 1) {
			selectedLocationTypeHeadingText += ', ';
		}

	}

	// update the filter heading text
	if (selectedLocationTypeHeadingText) {
		this.$locationTypeFilterWrapper.find(`.${self.options.baseClass}__dropdownFilter__heading__text`).text(selectedLocationTypeHeadingText);
	}
	else {
		this.$locationTypeFilterWrapper.find(`.${self.options.baseClass}__dropdownFilter__heading__text`).text(this.locationTypeFilterDefaultText);
	}

	// update location type filters cookie
	ConsentedCookie.set('jobListingLocationType', selectedLocationTypeIds.join('|'), 'functional');

	// location filters
	var selectedTopLevelLocationFilters = this.$locationFilter.jstree('get_top_checked', true);
	var selectedLocationFilters = this.$locationFilter.jstree('get_bottom_checked', true);
	var selectedLocationHeadingText = '';
	var selectedLocationIds = [];
	var selectedLocationFilterIds = [];

	// for each selected location filter
	for (let i = 0; i < selectedLocationFilters.length; i++) {
		selectedLocationIds = [...new Set([...selectedLocationIds, ...(selectedLocationFilters[i].data.locations || [])])]; // filter out duplicates
		selectedLocationFilterIds.push(selectedLocationFilters[i].id); // filter out duplicates
	}


	// getting our updated heading text
	for (let i = 0; i < selectedTopLevelLocationFilters.length; i++) {
		selectedLocationHeadingText += selectedTopLevelLocationFilters[i].text.trim();

		if (i < selectedTopLevelLocationFilters.length - 1) {
			selectedLocationHeadingText += ', ';
		}

	}

	// update the filter heading text
	if (selectedLocationHeadingText) {
		this.$locationFilterWrapper.find(`.${self.options.baseClass}__dropdownFilter__heading__text`).text(selectedLocationHeadingText);
	}
	else {
		this.$locationFilterWrapper.find(`.${self.options.baseClass}__dropdownFilter__heading__text`).text(this.locationFilterDefaultText);
	}

	// update location filters cookie
	ConsentedCookie.set('jobListingLocation', selectedLocationFilterIds.join('|'), 'functional');

	this.stopButtonPulsate();

	// now we pass all of our values off to the functions that do the work

	this.updateActiveFilterTags(
		query,
		selectedTopLevelDepartmentFilters,
		selectedTopLevelLocationFilters,
		selectedTopLevelEmploymentTypeFilters,
		selectedTopLevelCityFilters,
		selectedTopLevelLocationTypeFilters
	);

	this.updateJobResults(
		query,
		selectedDepartmentIds,
		selectedEmploymentTypeIds,
		selectedCityIds,
		selectedLocationIds,
		selectedLocationTypeIds
	);

};

// this function updates the filter tags
JobListing.prototype.updateActiveFilterTags = function (
	query,
	departmentFilters,
	locationFilters,
	employmentTypeFilters,
	cityFilters,
	locationTypeFilters
) {

	var self = this;

	gsap.set(self.$activeFilterTagsWrapper, {
		height: self.$activeFilterTagsWrapper.height()
	});

	gsap.timeline()
		.to(self.options.$el.find(`.${self.options.baseClass}__activeFilterTag`), {
			opacity: 0,
			duration: 0.2
		})
		.add(function () {
			self.addAllActiveFilterTags(
				query,
				departmentFilters,
				locationFilters,
				employmentTypeFilters,
				cityFilters,
				locationTypeFilters
			);
		});

};

// this function adds all the active filter tags
JobListing.prototype.addAllActiveFilterTags = function (
	query,
	departmentFilters,
	locationFilters,
	employmentTypeFilters,
	cityFilters,
	locationTypeFilters
) {

	var self = this;

	this.$activeFilterTagsWrapper.empty(); // clear out any existing filter tags

	// query filter tag
	if (query) {
		self.addActiveFilterTag('Search: ' + query, 'query');
	}

	// department filter tag
	if (departmentFilters.length) {

		let departmentFiltersString = 'Department: ';
		let fullDepartmentFiltersString = 'Department: ';

		for (let i = 0; i < departmentFilters.length; i++) {
			const departmentFilter = departmentFilters[i];
			// self.addActiveFilterTag('Department: '+departmentFilter.text, 'department');

			// shortened string, 1 or 2 items otherwise we show a count
			if (departmentFilters.length < 3) {
				if (i > 0) {
					departmentFiltersString += ` <span class="${self.options.baseClass}__activeFilterTag__value__separator">or</span> `;
				}
				departmentFiltersString += departmentFilter.text;
			}
			else {
				if (i == 0) {
					departmentFiltersString = `Department: ${departmentFilter.text} <span class="${self.options.baseClass}__activeFilterTag__value__separator">or</span> ` + (departmentFilters.length - 1) + ` others`;
				}
			}

			// full department string for title attribute
			if (i > 0) {
				fullDepartmentFiltersString += ` or `;
			}
			fullDepartmentFiltersString += departmentFilter.text.trim();

		}

		self.addActiveFilterTag(departmentFiltersString, 'department', fullDepartmentFiltersString);

	}

	// employment type filter tag
	if (employmentTypeFilters.length) {

		let employmentTypeFiltersString = 'Employment Type: ';
		let fullEmploymentTypeFiltersString = 'Employment Type: ';

		for (let i = 0; i < employmentTypeFilters.length; i++) {
			const employmentTypeFilter = employmentTypeFilters[i];

			// shortened string, 1 or 2 items otherwise we show a count
			if (employmentTypeFilters.length < 3) {
				if (i > 0) {
					employmentTypeFiltersString += ` <span class="${self.options.baseClass}__activeFilterTag__value__separator">or</span> `;
				}
				employmentTypeFiltersString += employmentTypeFilter.text;
			}
			else {
				if (i == 0) {
					employmentTypeFiltersString = `Employment Type: ${employmentTypeFilter.text} <span class="${self.options.baseClass}__activeFilterTag__value__separator">or</span> ` + (employmentTypeFilters.length - 1) + ` others`;
				}
			}

			// full employment string for title attribute
			if (i > 0) {
				fullEmploymentTypeFiltersString += ` or `;
			}
			fullEmploymentTypeFiltersString += employmentTypeFilter.text.trim();

		}

		self.addActiveFilterTag(employmentTypeFiltersString, 'employmentType', fullEmploymentTypeFiltersString);

	}

	// city filter tag
	if (cityFilters.length) {

		let cityFiltersString = 'City: ';
		let fullCityFiltersString = 'City: ';

		// get letters into an array so we can sort them
		let selectedCityLettersArray = [];
		for (let i = 0; i < cityFilters.length; i++) {
			const cityFilter = cityFilters[i];
			selectedCityLettersArray.push(cityFilter.text);
		}
		selectedCityLettersArray.sort();

		for (let i = 0; i < selectedCityLettersArray.length; i++) {
			const cityLetter = selectedCityLettersArray[i];

			// shortened string, 1 or 2 items otherwise we show a count

			if (selectedCityLettersArray.length < 3) {
				if (i > 0) {
					cityFiltersString += ` <span class="${self.options.baseClass}__activeFilterTag__value__separator">or</span> `;
				}
				cityFiltersString += cityLetter;
			}
			else {
				if (i == 0) {
					cityFiltersString = `City: ${cityLetter} <span class="${self.options.baseClass}__activeFilterTag__value__separator">or</span> ` + (selectedCityLettersArray.length - 1) + ` others`;
				}
			}

			// full city string for title attribute
			if (i > 0) {
				fullCityFiltersString += ` or `;
			}

			fullCityFiltersString += cityLetter;

		}

		self.addActiveFilterTag(cityFiltersString, 'city', fullCityFiltersString);

	}

	// location type filter tag
	if (locationTypeFilters.length) {

		let locationTypeFiltersString = 'Location Type: ';
		let fullLocationTypeFiltersString = 'Location Type: ';

		for (let i = 0; i < locationTypeFilters.length; i++) {
			const locationTypeFilter = locationTypeFilters[i];

			// shortened string, 1 or 2 items otherwise we show a count
			if (locationTypeFilters.length < 3) {
				if (i > 0) {
					locationTypeFiltersString += ` <span class="${self.options.baseClass}__activeFilterTag__value__separator">or</span> `;
				}
				locationTypeFiltersString += locationTypeFilter.text;
			}
			else {
				if (i == 0) {
					locationTypeFiltersString = `Location Type: ${locationTypeFilter.text} <span class="${self.options.baseClass}__activeFilterTag__value__separator">or</span> ` + (locationTypeFilters.length - 1) + ` others`;
				}
			}

			// full department string for title attribute
			if (i > 0) {
				fullLocationTypeFiltersString += ` or `;
			}
			fullLocationTypeFiltersString += locationTypeFilter.text.trim();

		}

		self.addActiveFilterTag(locationTypeFiltersString, 'locationType', fullLocationTypeFiltersString);

	}

	// location filter tag
	if (locationFilters.length) {

		let locationFiltersString = 'Location: ';
		let fullLocationFiltersString = 'Location: ';

		for (let i = 0; i < locationFilters.length; i++) {
			const locationFilter = locationFilters[i];

			// shortened string, 1 or 2 items otherwise we show a count
			if (locationFilters.length < 3) {
				if (i > 0) {
					locationFiltersString += ` <span class="${self.options.baseClass}__activeFilterTag__value__separator">or</span> `;
				}
				locationFiltersString += locationFilter.text;
			}
			else {
				if (i == 0) {
					locationFiltersString = `Location: ${locationFilter.text} <span class="${self.options.baseClass}__activeFilterTag__value__separator">or</span> ` + (locationFilters.length - 1) + ` others`;
				}
			}

			// full department string for title attribute
			if (i > 0) {
				fullLocationFiltersString += ` or `;
			}
			fullLocationFiltersString += locationFilter.text.trim();

		}

		self.addActiveFilterTag(locationFiltersString, 'location', fullLocationFiltersString);

	}

	// timeline that handles fading in our filter tags
	gsap.timeline()
		.to(self.$activeFilterTagsWrapper, {
			height: "auto",
			duration: 0.2
		})
		.fromTo(self.options.$el.find(`.${self.options.baseClass}__activeFilterTag`), {
			opacity: 0,
			scale: 0.92
		},
			{
				duration: 0.4,
				opacity: 1,
				scale: 1,
				stagger: {
					each: 0.08
				}
			});

};

// handles creating the dom element for a filter tag and adding it to the page
JobListing.prototype.addActiveFilterTag = function (tagText, tagType, tagTitle) {

	var self = this;

	let $activeFilterTagElement = `
		<div class="${self.options.baseClass}__activeFilterTag" data-tag-type="${tagType}" title="${tagTitle}">
			<span class="${self.options.baseClass}__activeFilterTag__closeX"></span>
			<span class="${self.options.baseClass}__activeFilterTag__value">${tagText}</span>
		</div>
	`;

	this.$activeFilterTagsWrapper.append($activeFilterTagElement);

};

// this function takes values for all filters and updates the job results
JobListing.prototype.updateJobResults = function (
	query,
	departmentFilters,
	employmentTypeFilters,
	cityFilters,
	locationFilters,
	locationTypeFilters,
	pageNumber
) {

	var self = this;

	this.submittedQuery = query;
	this.submittedDepartmentFilters = departmentFilters;
	this.submittedEmploymentTypeFilters = employmentTypeFilters;
	this.submittedCityFilters = cityFilters;
	this.submittedLocationFilters = locationFilters;
	this.submittedLocationTypeFilters = locationTypeFilters;

	// setting our ajax data that will be passed to our helper
	var ajaxData = {
		query: query,
		departmentFilters: JSON.stringify(departmentFilters),
		cityFilters: JSON.stringify(cityFilters),
		employmentTypeFilters: JSON.stringify(employmentTypeFilters),
		locationFilters: JSON.stringify(locationFilters),
		locationTypeFilters: JSON.stringify(locationTypeFilters),
		pageNumber: pageNumber,
	};

	// making an ajax call to our helpers module that does the actual work
	$.ajax({

		contentType: "application/json",
		url: '/actions/held-helpers-module/default/get-filtered-job-postings',

		data: ajaxData,

		success: function (data) {
			self.doneLoading(data);
		},

		error: function (data) {
			console.log('AJAX error');
			console.log(data);
		}

	});

};

// this function handles pagination
JobListing.prototype.goToPage = function (pageNumber) {

	var self = this;

	// set our loading state
	this.loading();

	// we use our update job results method here, we're not using craft built in pagination but instead
	// we handle pagination inside our helper module
	this.updateJobResults(
		this.submittedQuery,
		this.submittedDepartmentFilters,
		this.submittedEmploymentTypeFilters,
		this.submittedCityFilters,
		this.submittedLocationFilters,
		this.submittedLocationTypeFilters,
		pageNumber
	);

};

// this function sets the jobListing to the loading state
JobListing.prototype.loading = function () {

	var self = this;

	// set loadStartTime to the current time, this will be used to make sure the loading state is given enough time
	// for the animations to appear properly
	this.loadStartTime = new Date().getTime() / 1000;

	// close our dropdown filters
	self.closeAllDropdownFilters();

	// set our height wrapper to a static height so it can be animated to auto
	var currentHeight = this.$heightAdjustWrapper.outerHeight();
	gsap.set(self.$heightAdjustWrapper, {
		height: currentHeight
	});

	// if we're scrolled down, scroll the user back to the top of the results - this is primarily used when the user
	// clicks a pagination link
	if ($(document).scrollTop() > self.options.$el.offset().top) {
		gsap.to(window, { duration: 0.8, scrollTo: self.options.$el.offset().top });
	}

	// our loading timeline
	gsap.timeline({

	})
		.add(function () {
			// set the submit button to the loading state
			let buttonLoadingClass = `${self.options.baseClass}__submitFiltersButton--loading`;
			self.$filterButtonWrapper.addClass(buttonLoadingClass);
		})
		// show our filters loader (the overlay over the filters that disallows them from being changed while loading)
		.set(self.$filtersLoader, {
			display: 'block'
		})
		.to(self.$filtersLoader, {
			opacity: 1
		})
		// fade out the results containers
		.to(self.$resultsContainer, {
			duration: 0.15,
			opacity: 0
		}, 0)
		.set(self.$resultsContainer, {
			display: 'none'
		})
		.to(self.$noResultsContainer, {
			duration: 0.15,
			opacity: 0
		}, 0)
		.set(self.$noResultsContainer, {
			display: 'none'
		})
		// fade out the pagination wrapper
		.to(self.$paginationWrapper, {
			duration: 0.15,
			opacity: 0
		}, 0)
		.set(self.$paginationWrapper, {
			display: 'none'
		})
		// show our placeholders while loading
		.set(self.$placeholdersContainer, {
			display: 'flex'
		}, 0.15)
		// animate our wrapper to the current height
		.to(self.$heightAdjustWrapper, {
			duration: 0.2,
			height: "auto"
		}, ">-0.05")
		.fromTo(self.$placeholdersContainer,
			{
				opacity: 0
			},
			{
				duration: 0.35,
				opacity: 1
			}
			, ">-0.05"
		);

	// .to(self.$placeholdersContainer, {
	// 	duration: 0.3,
	// 	opacity: 1
	// }, ">-0.05");

};

// this function is called when loading is complete
JobListing.prototype.doneLoading = function (data) {

	var self = this;

	var pageInfo = data.pageInfo;
	var jobData = data.jobs;

	var currTime = new Date().getTime() / 1000;

	// make sure loading took long enough to show all of the loading animations
	if ((currTime - this.loadStartTime) < 0.8) {
		setTimeout(function () { self.doneLoading(data); }, 250);
		return;
	}

	// if no results were found
	if (jobData.length < 1) {
		self.noResults();
		return;
	}

	// update our dom elements
	this.updateJobResultsDom(jobData);
	this.updatePaginationDom(pageInfo.currentPage, pageInfo.totalPages);

	// set our height wrapper to a static height so it can be animated to auto
	var currentHeight = this.$heightAdjustWrapper.outerHeight();
	gsap.set(self.$heightAdjustWrapper, {
		height: currentHeight
	});

	// run our done loading animations
	var doneLoadingTimeline = gsap.timeline({

	})
		// hide our filters loader (the overlay over the filters that disallows them from being changed while loading)
		.to(self.$filtersLoader, {
			duration: 0.5,
			opacity: 0
		})
		.set(self.$filtersLoader, {
			display: 'none'
		})
		// remove the loading state from the submit button
		.add(function () {
			let buttonLoadingClass = `${self.options.baseClass}__submitFiltersButton--loading`;
			self.$filterButtonWrapper.removeClass(buttonLoadingClass);
		})
		// hide the placeholders
		.to(self.$placeholdersContainer, {
			duration: 0.5,
			opacity: 0
		}, 0)
		.set(self.$placeholdersContainer, {
			display: 'none'
		})
		// fade in the results container
		.set(self.$resultsContainer, {
			display: 'flex',
			opacity: 1
		});

	// if there is multiple pages, show the pagination
	if (pageInfo.totalPages > 1) {

		doneLoadingTimeline
			.set(self.$paginationWrapper, {
				display: 'flex'
			});

	}
	// otherwise, hide the pagination
	else {

		doneLoadingTimeline
			.set(self.$paginationWrapper, {
				display: 'none'
			});

	}

	// animate our wrapper to the current height
	doneLoadingTimeline
		.to(self.$heightAdjustWrapper, {
			duration: 0.2,
			height: "auto"
		});

	// animate in each of our results in a staggered fashion
	doneLoadingTimeline
		.fromTo(self.$resultsContainer.find(`.${self.options.baseClass}__resultWrapper`),
			{
				opacity: 0,
				scale: 0.92
			},
			{
				duration: 0.4,
				opacity: 1,
				scale: 1,
				stagger: {
					each: 0.08
				}
			}
		);

	// if there are multiple pages, fade in the pagination
	if (pageInfo.totalPages > 1) {

		doneLoadingTimeline
			.fromTo(self.$paginationWrapper,
				{
					opacity: 0
				},
				{
					opacity: 1
				}, "<"
			);

	}

};

// this function updates the pagination dom elements
JobListing.prototype.updatePaginationDom = function (currentPage, totalPages) {

	var self = this;

	this.$paginationWrapper.removeClass(`${self.options.baseClass}__pagination--hidden`);

	// if there is only a single page, hide the pagination
	if (totalPages == 1) {
		this.$paginationWrapper.addClass(`${self.options.baseClass}__pagination--hidden`);
		return;
	}

	currentPage = parseInt(currentPage);
	totalPages = parseInt(totalPages);

	// clear out the pagination wrapper to get it ready for new dom elements
	this.$paginationWrapper.empty();

	// the rest of the blocks in this function are similar to how we handle pagination in a craft template - they handle the logic
	// of setting up our pagination dom elements based on how many pages there are and what page we are currently on.

	if (currentPage != 1) {
		this.$paginationWrapper.append(
			`<div data-page="${currentPage - 1}" class="${self.options.baseClass}__pagination__link ${self.options.baseClass}__pagination__link--previous">Prev</div>`
		);
	}

	if (currentPage > 1) {
		this.$paginationWrapper.append(
			`<div data-page="1" class="${self.options.baseClass}__pagination__link">1</div>`
		);
	}

	if (currentPage == 3) {
		this.$paginationWrapper.append(
			`<div data-page="2" class="${self.options.baseClass}__pagination__link">2</div>`
		);
	}

	if (currentPage == 4) {
		this.$paginationWrapper.append(
			`<div data-page="2" class="${self.options.baseClass}__pagination__link">2</div>
			<div data-page="3" class="${self.options.baseClass}__pagination__link">3</div>`
		);
	}

	if (currentPage > 4) {
		this.$paginationWrapper.append(
			`<div class="${self.options.baseClass}__pagination__link ${self.options.baseClass}__pagination__link--separator">...</div>
			<div data-page="${currentPage - 2}" class="${self.options.baseClass}__pagination__link">${currentPage - 2}</div>
			<div data-page="${currentPage - 1}" class="${self.options.baseClass}__pagination__link">${currentPage - 1}</div>`
		);
	}

	this.$paginationWrapper.append(
		`<div class="${self.options.baseClass}__pagination__link ${self.options.baseClass}__pagination__link--current">${currentPage}</div>`
	);

	if (totalPages - currentPage > 3) {
		this.$paginationWrapper.append(
			`<div data-page="${currentPage + 1}" class="${self.options.baseClass}__pagination__link">${currentPage + 1}</div>
			<div data-page="${currentPage + 2}" class="${self.options.baseClass}__pagination__link">${currentPage + 2}</div>
			<div class="${self.options.baseClass}__pagination__link ${self.options.baseClass}__pagination__link--separator">...</div>`
		);
	}

	if (totalPages - currentPage == 3) {
		this.$paginationWrapper.append(
			`<div data-page="${currentPage + 1}" class="${self.options.baseClass}__pagination__link">${currentPage + 1}</div>
			<div data-page="${currentPage + 2}" class="${self.options.baseClass}__pagination__link">${currentPage + 2}</div>`
		);
	}

	if (totalPages - currentPage == 2) {
		this.$paginationWrapper.append(
			`<div data-page="${currentPage + 1}" class="${self.options.baseClass}__pagination__link">${currentPage + 1}</div>`
		);
	}

	if (totalPages - currentPage > 0) {
		this.$paginationWrapper.append(
			`<div data-page="${totalPages}" class="${self.options.baseClass}__pagination__link">${totalPages}</div>`
		);
	}

	if (currentPage != totalPages) {
		this.$paginationWrapper.append(
			`<div data-page="${currentPage + 1}" class="${self.options.baseClass}__pagination__link ${self.options.baseClass}__pagination__link--next">Next</div>`
		);
	}

};

// update our job results dom elements
JobListing.prototype.updateJobResultsDom = function (jobData) {

	var self = this;

	// clear out our results container to get it ready to fill in with new dom elements
	this.$resultsContainer.empty();

	// for each job result
	for (let i = 0; i < jobData.length; i++) {

		// get our job result dom element
		let $jobDomElement = self.getPersonDomElement(jobData[i]);

		// add the dom element to the results container
		this.$resultsContainer.append($jobDomElement);

	}

};

// this function is used when there are no results
JobListing.prototype.noResults = function (jobData) {

	var self = this;

	// set our height wrapper to a static height so it can be animated to auto
	var currentHeight = this.$heightAdjustWrapper.outerHeight();
	gsap.set(self.$heightAdjustWrapper, {
		height: currentHeight
	});

	// our animation timeline for when there are no results
	var noResultsTimeline = gsap.timeline({

	})
		// hide our filters loader (the overlay over the filters that disallows them from being changed while loading)
		.to(self.$filtersLoader, {
			duration: 0.5,
			opacity: 0
		})
		.set(self.$filtersLoader, {
			display: 'none'
		})
		// remove the loading state from the submit button
		.add(function () {
			let buttonLoadingClass = `${self.options.baseClass}__submitFiltersButton--loading`;
			self.$filterButtonWrapper.removeClass(buttonLoadingClass);
		})
		// fade out our placeholders
		.to(self.$placeholdersContainer, {
			duration: 0.5,
			opacity: 0
		}, 0)
		.set(self.$placeholdersContainer, {
			display: 'none'
		})
		// show the no results container that indicates to the user that there are no results
		.set(self.$noResultsContainer, {
			display: 'flex'
		})
		// hide the pagination
		.set(self.$paginationWrapper, {
			display: 'none'
		})
		// set the wrapper to the current height
		.to(self.$heightAdjustWrapper, {
			duration: 0.2,
			height: "auto"
		})
		// fade in the no results container that indicates to the user that there are no results
		.to(self.$noResultsContainer,
			{
				duration: 0.4,
				opacity: 1
			}
		);

};

// this function handles creating individual job result dom elements
JobListing.prototype.getPersonDomElement = function (jobData) {

	var self = this;

	// clone our job result template
	var $jobDomElement = this.$jobResultTemplate.clone()
		.removeClass(`${self.options.baseClass}__resultWrapper--resultTemplate`);

	// if this is a translated site, format the job URL accordingly
	if (LocaleHost.isAllowedHost(window.location.hostname)) {
		jobData.url = LocaleHost.localizeUrl(jobData.url, window.location.hostname);
	}

	// job title
	$jobDomElement.find(`.${self.options.baseClass}__job__title`).text(jobData.title);

	// job type
	if (jobData.location_type) {
		$jobDomElement.find(`.${self.options.baseClass}__job__type`).text(jobData.location_type);
	} else {
		$jobDomElement.find(`.${self.options.baseClass}__job__type`).text('---');
	}

	// job location
	if (jobData.location) {
		$jobDomElement.find(`.${self.options.baseClass}__job__address`).text(jobData.location);
	}
	else {
		$jobDomElement.find(`.${self.options.baseClass}__job__address`).remove();
	}

	// job department
	if (jobData.department) {
		$jobDomElement.find(`.${self.options.baseClass}__job__department`).text(jobData.department);
	}
	else {
		$jobDomElement.find(`.${self.options.baseClass}__job__department`).remove();
	}

	// job time
	if (jobData.employment_type) {
		$jobDomElement.find(`.${self.options.baseClass}__job__time`).text(jobData.employment_type);
	}
	else {
		$jobDomElement.find(`.${self.options.baseClass}__job__time`).remove();
	}


	// job url
	if (jobData.url) {
		$jobDomElement.find(`.${self.options.baseClass}__job__cta`).attr('href', jobData.url);
	}

	// job description
	if (jobData.description) {
		$jobDomElement.find(`.${self.options.baseClass}__job__description`).empty().append($.parseHTML(jobData.description));
	}
	else {
		$jobDomElement.find(`.${self.options.baseClass}__job__description`).remove();
	}




	// return the dom element
	return $jobDomElement;

};

// this function handles pulsating the button indicate to the user that the filters have been changed
// and that the button needs to be clicked to run the filtering
JobListing.prototype.pulsateButton = function () {

	var self = this;

	let activeClass = `${self.options.baseClass}__submitFiltersButton--active`;

	this.$filterButtonWrapper.addClass(activeClass);

};

// this function stops the button pulsating, it is typically used when the filters are submitted
JobListing.prototype.stopButtonPulsate = function () {

	var self = this;

	let activeClass = `${self.options.baseClass}__submitFiltersButton--active`;

	this.$filterButtonWrapper.removeClass(activeClass);

};

export default JobListing;
